import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { initClientErrorLogging } from './utils/client-error-report.ts'

initClientErrorLogging()

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

if (ENV.MODE === 'production' && 'serviceWorker' in navigator) {
	void import('./utils/sw-update.client.ts').then(({ registerServiceWorker }) =>
		registerServiceWorker(),
	)
}

startTransition(() => {
	hydrateRoot(document, <HydratedRouter />)
})
